// extracted by mini-css-extract-plugin
export default {"fileSelect":"FileUpload_fileSelect__LdR03","fakeLabel":"FileUpload_fakeLabel__st4rX","filenameWrapper":"FileUpload_filenameWrapper__UQY55"};